<div class="container">
    <!-- Language Selection -->
    <div class="dropdown-container error-container">
        <mat-select
            [(ngModel)]="input.language"
            (ngModelChange)="getInputValue()"
            placeholder="Language"
            class="input-element language-dropdown"
        >
            <ng-container *ngFor="let language of languageOptions">
                <mat-option
                    *ngIf="shouldInclude(language)"
                    [value]="language.value"
                >
                    {{ language.label }}
                </mat-option>
            </ng-container>
        </mat-select>
        <app-validation-error-label
            *ngIf="getLanguageError()"
            [message]="
                'trend-graph.labels.add-language.no-language-selected'
                    | translate
            "
        ></app-validation-error-label>
    </div>
    <!-- Text Input -->
    <div style="flex: 1">
        <div style="flex: 1">
            <input
                #titleInput
                (focus)="getLanguageError()"
                class="input-element"
                [(ngModel)]="input.text"
                (ngModelChange)="getInputValue()"
                type="text"
                style="width: 100%"
            />
            <app-validation-error-label
                *ngIf="getInputValue()"
                [message]="
                    'trend-graph.labels.add-language.input-error'
                        | translate: { language: 'English' }
                "
            ></app-validation-error-label>
        </div>
    </div>
</div>
